import { Component, inject, output, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/api/auth.service';
import { ThemeService } from '../../core/services/conf/theme.service';
import { WorkSessionStateService } from '../../core/services/api/work-session-state.service';
import { ProfileComponent } from '../../modules/profile/profile.component';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [CommonModule, RouterModule, ProfileComponent],
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {
    auth = inject(AuthService);
    theme = inject(ThemeService);
    sessionState = inject(WorkSessionStateService);
    menuToggle = output<void>();
    pageTitle = computed(() => `Bienvenido/a a Tickets - ${this.auth.fullName()} - ${this.auth.role()}`);
    profileVisible = signal(false);

    openProfile(): void {
        this.profileVisible.set(true);
    }

    closeProfile(): void {
        this.profileVisible.set(false);
    }
}
